/**
 * SubmitSuccess - Erfolgsseite nach Anamnese-Übermittlung
 */

import React, { useEffect, useState } from 'react';
import {
  Box,
  Paper,
  Typography
} from '@mui/material';
import {
  CheckCircle as SuccessIcon
} from '@mui/icons-material';

const SubmitSuccess = () => {
  const [praxisName] = useState('Zahnarztpraxis Dr. Hezel');
  const [terminDatum, setTerminDatum] = useState(null);

  useEffect(() => {
    // Lade Termin-Datum aus Session Storage
    const datum = sessionStorage.getItem('termin_datum');
    if (datum) {
      setTerminDatum(datum);
    }
  }, []);

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        p: { xs: 2, sm: 3 },
        background: 'linear-gradient(135deg, #1a6ead 0%, #004c80 100%)'
      }}
    >
      <Paper
        elevation={3}
        sx={{
          maxWidth: { xs: '100%', sm: 600 },
          width: '100%',
          p: { xs: 3, sm: 4 },
          textAlign: 'center',
          borderRadius: { xs: 2, sm: 3 }
        }}
      >
        <SuccessIcon sx={{ fontSize: 100, color: '#4caf50' }} />

        <Typography variant="h4" sx={{ mt: 2, mb: 1, color: '#4caf50' }}>
          Vielen Dank!
        </Typography>

        <Typography variant="h6" color="text.primary" sx={{ mb: 2 }}>
          Ihre Anamnese wurde erfolgreich übermittelt.
        </Typography>

        <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
          Ihre Angaben wurden sicher verschlüsselt an die Praxis übertragen.
          Das Praxisteam wird Ihre Daten vor Ihrem Termin prüfen.
        </Typography>

        {terminDatum && (
          <Paper
            variant="outlined"
            sx={{
              p: 2,
              mb: 3,
              backgroundColor: '#f8f9fa'
            }}
          >
            <Typography variant="body2" color="text.secondary">
              Ihr Termin:
            </Typography>
            <Typography variant="h6" color="primary">
              {terminDatum}
            </Typography>
          </Paper>
        )}

        <Box
          sx={{
            mt: 4,
            pt: 3,
            borderTop: '1px solid #e0e0e0'
          }}
        >
          <Typography variant="body2" color="text.secondary">
            {praxisName}
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
            Sie können dieses Fenster jetzt schließen.
          </Typography>
        </Box>
      </Paper>
    </Box>
  );
};

export default SubmitSuccess;
